import { z } from 'zod'

export const selectedUserViewSchema = z.object({
  password: z.string().min(1),
  remember_me: z.boolean()
})
